import React from "react";
import "../../App.css";
import CompilerError from "../CompilerError";
import Problem from "../Problem";
import Suggestion from "../Suggestion";
import BadExample from "../BadExample";
import GoodExample from "../GoodExample";
import { makeClassStubIfUnknown, makeDemoValue } from "../../demoValues";

class IncorrectDimensionExpression3 extends React.Component {

  render() {
    const demoArray = makeDemoValue(`${this.props.typeName}[]`, true);
    const classPlaceholder = <div className="Indent-0">{makeClassStubIfUnknown(this.props.typeName)}</div>;

    return <CompilerError
      title="Cannot define dimension expressions when an array initializer is provided"
      translation="You have defined an array twice."
      embed={this.props.embed} 
      fontSize={this.props.fontSize}
    >
      <Problem
        title="You may have used both methods to construct an array together"
      >
        <Suggestion title="Choose only one of the methods to make an array.">
          <BadExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName}[] {this.props.arrName} = new {this.props.typeName}[5] {demoArray};</div>
          </BadExample>

          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName}[] {this.props.arrName} = new {this.props.typeName}[5];</div>
          </GoodExample>
          <GoodExample>
            {classPlaceholder}
            <div className="Indent-0">{this.props.typeName}[] {this.props.arrName} = {demoArray};</div>
          </GoodExample>
        </Suggestion>
      </Problem>
    </CompilerError>;
  }
}

export default IncorrectDimensionExpression3;
